export enum MatchStatusEnum {
  ACTIVE = "ACTIVE", /// Quando o match está aguardando para ser executado.
  PROCESSING = "PROCESSING", /// Quando o match está sendo executado.
  FULFILLED = "FULFILLED", /// Quando o match está concluido.
  REMOVED = "REMOVED", /// Caso ocorra algum problema na formalização.
  EXPIRED = "EXPIRED", /// Caso o token associado expire.
}
